<template>
    <div>
        <b-row>
            <b-col sm="9">
                <div>
                <b-img :src="imgUrl(images[currentIndex])"
                       @click="openImage(images[currentIndex])"
                       class="img-link"
                       fluid>
                </b-img>
                </div>
            </b-col>

            <b-col align="center">
                <b-link v-for="(img, index) in images"
                        @click="viewImage(index)"
                        :key="index">
                <b-img width="125px;"
                       class="mr-2"
                       thumbnail
                       block
                       :src="imgUrl(img)">
                </b-img>
                </b-link>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "Images",
        props: [ 'images' ],
        data() {
            return {
                currentIndex: 0,
            }
        },
        methods: {
            imgUrl(img) {
                return process.env.VUE_APP_IMAGES_URL + img.url;
            },
            viewImage(index) {
                this.currentIndex = index;
            },
            openImage(img) {
                window.open(this.imgUrl(img), 'imageViewer');
            }
        }
    }
</script>

<style scoped>
    .img-link:hover {
        cursor: pointer;
    }
</style>